import { useIntl } from 'react-intl';

import { addParams } from '@xing-com/xing-tracking';

import * as Styled from './create-job-button.styled';

export const CreateJobButton: React.FC = () => {
  const { formatMessage } = useIntl();
  const targetURL = 'https://www.xing.com/recruiting/jobs/create';
  const trackingURL = addParams(targetURL, {
    nwt_nav: 'boneyard_job_ad',
    sc_cmp: 'oow5eb8bc92',
  });
  const commonProps = {
    'data-testid': 'styled-create-job-button',
    to: trackingURL,
    variant: 'primary' as const,
  };

  return (
    <>
      <Styled.ButtonSmallWhenTopBar {...commonProps} $size="small" size="small">
        {formatMessage({ id: 'MAINNAV_CREATE_JOB' })}
      </Styled.ButtonSmallWhenTopBar>
      <Styled.ButtonSmallWhenTopBar
        {...commonProps}
        $size="medium"
        size="medium"
      >
        {formatMessage({ id: 'MAINNAV_JOBS_EASY_CREATE' })}
      </Styled.ButtonSmallWhenTopBar>
    </>
  );
};
